import styled, { css } from 'styled-components';

const defaultStyle = css`
  background-color: ${(props) => props.isIcon ? "transparent" : props.theme.colors.colorButton};
  color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelButton : props.theme.colors.colorLabelLightButton};
  border: ${(props) => props.isIcon ? "transparent" :  props.theme.colors.colorButton} 2px solid;
  font-size: 14px;
  font-weight: 900;
  border-radius: ${(props) => props.br20 ? '20px' : '4px'};
  &:hover {
    background-color: ${(props) => props.isIcon ? props.theme.colors.colorButton : props.theme.colors.colorLightButton};
    color: ${(props) => props.isIcon ? props.theme.colors.colorLabelLightButton : props.theme.colors.colorLabelButton};
    i{
      color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelLightButton :  props.theme.colors.colorLabelButton } !important;
    }
    span {
      color: ${(props) =>  props.theme.colors.colorLabelButton} !important;
    }
  }
  &:focus {
    background-color: ${(props) => props.isIcon ? props.theme.colors.colorButton : props.theme.colors.colorLightButton};
    color: ${(props) => props.isIcon ? props.theme.colors.colorLabelLightButton : props.theme.colors.colorLabelButton};
    i{
      color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelLightButton :  props.theme.colors.colorLabelButton } !important;
    }
    span {
      color: ${(props) =>  props.theme.colors.colorLabelButton} !important;
    }
  }
  &:active {
    background-color: ${(props) => props.isIcon ? props.theme.colors.colorButton : props.theme.colors.colorLightButton};
    color: ${(props) => props.isIcon ? props.theme.colors.colorLabelLightButton : props.theme.colors.colorLabelButton};
    i{
      color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelLightButton :  props.theme.colors.colorLabelButton } !important;
    }
    span {
      color: ${(props) =>  props.theme.colors.colorLabelButton} !important;
    }
  }
  i{
    color: ${(props) => props.isIcon ?  props.theme.colors.colorButton : props.theme.colors.colorLabelButton } !important;
  }
  >* span {
    color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelButton : props.theme.colors.colorLabelLightButton};
  }
`;

const govBrStyled = css`
  background-color: ${(props) => props.isIcon ? "transparent" : props.theme.colors.buttonGovBr};
  color: ${(props) => props.isIcon ?  props.theme.colors.buttonGovBr : props.theme.colors.colorLabelLightButton};
  border: ${(props) => props.isIcon ? "transparent" :  props.theme.colors.buttonGovBr} 2px solid;
  font-size: 14px;
  font-weight: 900;
  border-radius: ${(props) => props.br20 ? '20px' : '4px'};
  &:hover {
    background-color: ${(props) => props.isIcon ? props.theme.colors.buttonGovBr : props.theme.colors.buttonLightGovBr};
    color: ${(props) => props.isIcon ? props.theme.colors.colorLabelLightButton : props.theme.colors.buttonGovBr};
    i{
      color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelLightButton :  props.theme.colors.buttonGovBr } !important;
    }
    span {
      color: ${(props) =>  props.theme.colors.buttonGovBr} !important;
    }
  }
  &:focus {
    background-color: ${(props) => props.isIcon ? props.theme.colors.buttonGovBr : props.theme.colors.buttonLightGovBr};
    color: ${(props) => props.isIcon ? props.theme.colors.colorLabelLightButton : props.theme.colors.buttonGovBr};
    i{
      color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelLightButton :  props.theme.colors.buttonGovBr } !important;
    }
    span {
      color: ${(props) =>  props.theme.colors.buttonGovBr} !important;
    }
  }
  &:active {
    background-color: ${(props) => props.isIcon ? props.theme.colors.buttonGovBr : props.theme.colors.buttonLightGovBr};
    color: ${(props) => props.isIcon ? props.theme.colors.colorLabelLightButton : props.theme.colors.buttonGovBr};
    i{
      color: ${(props) => props.isIcon ?  props.theme.colors.colorLabelLightButton :  props.theme.colors.buttonGovBr } !important;
    }
    span {
      color: ${(props) =>  props.theme.colors.buttonGovBr} !important;
    }
  }
  i{
    color: ${(props) => props.isIcon ?  props.theme.colors.buttonGovBr : props.theme.colors.colorLabelLightButton } !important;
  }
`;

export const SdsButtonStyled = styled.button`
  ${(props) => props.govBr ? govBrStyled : defaultStyle }
`;
